export default "__VITE_ASSET__DS77r6yA__"